import { isAddressBlank } from "src/components/Inputs/Address/Book/helpers";
import { Answer } from "src/services/formTemplate";
import * as AF from "src/types/formTemplate";

export function hasInvalidAddressCoordinates(
  questions: readonly AF.Question<AF.WithId>[],
  values: Answer.FormikValues
): boolean {
  return questions.some((question) => {
    if (question.type !== AF.AddressType) return false;
    const answer = values[question.id];
    if (typeof answer !== "object" || answer === null || answer === undefined)
      return false;
    const addressAnswer = answer as {
      street_address?: string;
      city?: string;
      state?: string;
      zip_code?: string;
      geom?: { coordinates?: [number, number] } | null;
    };
    const isBlank = isAddressBlank({
      street_address: addressAnswer.street_address ?? "",
      street_address_line_2: "",
      city: addressAnswer.city ?? "",
      state: addressAnswer.state ?? "",
      zip_code: addressAnswer.zip_code ?? "",
    });
    const isRequired = question.requirement === "Required";
    if (isBlank && !isRequired) return false;
    const coords = addressAnswer.geom?.coordinates;
    return (
      !coords ||
      !Array.isArray(coords) ||
      coords.length !== 2 ||
      typeof coords[0] !== "number" ||
      typeof coords[1] !== "number"
    );
  });
}
